import React from 'react';
import BottomSection from '../components/BottomSection';
import cooperationHero from '../assets/images/cooperation-hero.jpg';
import { useSeo } from '../seo';

function CooperationPage() {
  useSeo('cooperation');

  return (
    <main className="join-us-page">
      <section className="join-us-section">
        <img className="join-us-image" src={cooperationHero} alt="价探品牌合作页面头图" />
      </section>

      <section className="join-us-section cooperation-title-section">
        <div className="cooperation-title-block">
          <h1>品牌合作</h1>
          <p>Brand Collaboration</p>
          <div className="cooperation-title-copy">
            <div className="cooperation-title-line"  style={{ marginTop: '2%' }}>
              <span className="cooperation-title-label">合作微信：</span>
              <span className="cooperation-title-value">18256581547</span>
            </div>
            <div className="cooperation-title-line" style={{ marginTop: '-2%' }}>
              <span className="cooperation-title-label">合作邮箱：</span>
              <span className="cooperation-title-value">caolongmei@pricetag.com</span>
            </div>
          </div>
        </div>
      </section>

      <BottomSection />
    </main>
  );
}

export default CooperationPage;
